import { useTranslations } from '@vocab/react';
import { Text, Box, IconStar, Inline } from 'braid-design-system';
import { type FC, useState } from 'react';

import translations from './.vocab';

import * as styles from './StarRatingInput.css';

interface Props {
  onClick: (x: number) => number;
  rating: number;
}

export const StarRatingInput: FC<Props> = ({ onClick, rating }) => {
  const [currentHoverIndex, setCurrentHoverIndex] = useState(0);
  const { t } = useTranslations(translations);
  const onStarClick = (ratingValue: number) => {
    const newRatingValue = onClick(ratingValue);
    setCurrentHoverIndex(newRatingValue);
  };

  return (
    <Box data-cy="star-rating-input">
      <Inline space="xxsmall">
        {[1, 2, 3, 4, 5].map((starNumber) => (
          <Box
            key={`star-rating-${starNumber}`}
            aria-label={t('Star rating index', { index: starNumber })}
            role="button"
            tabIndex={0}
            onMouseLeave={() => setCurrentHoverIndex(0)}
            onMouseEnter={() => setCurrentHoverIndex(starNumber)}
            onClick={() => onStarClick(starNumber)}
            cursor="pointer"
          >
            <Text size="small">
              <Box className={styles.star}>
                <IconStar
                  titleId={`IconStar-${starNumber}`}
                  title={t('Star rating image')}
                  active={
                    rating >= starNumber || currentHoverIndex >= starNumber
                  }
                />
              </Box>
            </Text>
          </Box>
        ))}
      </Inline>
    </Box>
  );
};
